const modules = import.meta.glob('./*.json', { eager: true })

const translations = {}

for (const filePath in modules) {
    const module = modules[filePath]
    const data = module.default || module

    const key = filePath.replace('./', '').replace('.json', '')

    translations[key] = data
}

export default translations
